import Button from "react-bootstrap/esm/Button";
import classNames from 'classnames';

function FilterItem({title, item, activeItem, setContentType}){
    
    let classes = classNames({
        'filterItem':true,
        'filterItem--active':item === activeItem
    })

    return (
        <Button className={classes} onClick={() => setContentType(item)}>{title}</Button>
    );
}

export default FilterItem;